import { Check } from "lucide-react";
import { Reveal, Stagger, StaggerItem } from "@/components/Motion";
import BookingDialog from "@/components/BookingDialog";
import Seo from "@/components/Seo";
import { IMAGES } from "@/data/content";

const CREDENTIALS = [
  "Operatore Olistico",
  "Spiritual Coach",
  "Operatore PHYL®",
  "Insegnante e praticante dei Registri Akashici",
  "Praticante di Pranoterapia e Cristalloterapia",
  "Facilitatore di regressioni alle vite passate",
];

const JOURNEY = [
  { year: "Formazione", text: "Percorso di studio e pratica nelle discipline olistiche ed energetiche, con specializzazione nei Registri Akashici." },
  { year: "Qualifica PHYL®", text: "Certificazione come Operatore PHYL®, metodo di riequilibrio energetico." },
  { year: "Insegnamento", text: "Attività come insegnante dei Registri Akashici, formando nuovi praticanti con metodo ed etica." },
  { year: "Lux Aeterna", text: "La nascita di un ecosistema premium che unisce consulenze, formazione ed eventi attorno all'Akasha." },
];

export default function Fondatore() {
  return (
    <div className="pt-24 pb-28 min-h-screen">
      <Seo title="Davide Bellafiore — Il Fondatore" description="Davide Bellafiore: operatore olistico, spiritual coach, Operatore PHYL® e insegnante dei Registri Akashici. Il fondatore di LUX AETERNA e della Lux Academy." image={IMAGES.founder || undefined} type="profile"
        jsonLd={{ "@context": "https://schema.org", "@type": "Person", name: "Davide Bellafiore", jobTitle: "Operatore olistico, spiritual coach, insegnante dei Registri Akashici", worksFor: { "@type": "Organization", name: "LUX AETERNA" }, knowsAbout: ["Registri Akashici", "Channeling", "Medianità", "Pranoterapia", "Cristalloterapia"] }} />
      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-12 grid lg:grid-cols-2 gap-16 items-center">
        <Reveal>
          <div className="relative rounded-2xl overflow-hidden aspect-[4/5] max-w-md">
            <img src={IMAGES.founder} alt="Davide Bellafiore" className="w-full h-full object-cover" data-testid="founder-photo" />
            <div className="absolute inset-0 ring-1 ring-inset ring-gold/20 rounded-2xl" />
          </div>
        </Reveal>
        <div>
          <p className="text-xs uppercase tracking-[0.25em] text-gold mb-5">Il fondatore</p>
          <h1 className="font-display text-5xl sm:text-6xl text-[#2A1F14] leading-tight mb-4">Davide Bellafiore</h1>
          <p className="font-display italic text-xl text-gold mb-8">Operatore olistico e spiritual coach</p>
          <p className="text-[#2A1F14]/65 text-lg leading-relaxed mb-6">Davide accompagna persone e percorsi con un approccio che unisce profondità spirituale, metodo e rispetto assoluto per l'unicità di ciascuno. La sua visione è quella di una spiritualità moderna: sobria, competente e trasformativa.</p>
          <p className="text-[#2A1F14]/55 leading-relaxed">Attraverso i Registri Akashici, i trattamenti energetici e i percorsi di crescita personale, guida chi sceglie di intraprendere un cammino autentico verso la propria essenza — con eleganza, ascolto e presenza reale.</p>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 py-24">
        <Reveal><h2 className="font-display text-3xl text-[#2A1F14] mb-10">Competenze e certificazioni</h2></Reveal>
        <Stagger className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {CREDENTIALS.map((c) => (
            <StaggerItem key={c}>
              <div className="flex items-start gap-3 border border-[#2A1F14]/10 rounded-xl p-6 h-full">
                <Check size={18} className="text-gold mt-0.5 shrink-0" />
                <span className="text-[#2A1F14]/75">{c}</span>
              </div>
            </StaggerItem>
          ))}
        </Stagger>
      </section>

      <section className="bg-[#EFE3CE] py-24">
        <div className="max-w-[1000px] mx-auto px-6 lg:px-10">
          <Reveal><h2 className="font-display text-3xl text-[#2A1F14] mb-14">Il percorso</h2></Reveal>
          <div className="space-y-px">
            {JOURNEY.map((j, i) => (
              <Reveal key={i} delay={i * 0.05}>
                <div className="grid md:grid-cols-12 gap-6 border-t border-[#2A1F14]/10 py-8">
                  <span className="md:col-span-3 font-display text-xl text-gold">{j.year}</span>
                  <p className="md:col-span-9 text-[#2A1F14]/60 leading-relaxed">{j.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
          <div className="mt-16 text-center">
            <BookingDialog title="Prenota con Davide" presets={{ type: "consulenza", service: "Consulenza con il fondatore" }}
              trigger={<button data-testid="founder-book" className="px-8 py-4 rounded-full bg-gold text-black text-sm font-medium hover:bg-[#D4A056] transition-colors">Prenota una consulenza</button>} />
          </div>
        </div>
      </section>
    </div>
  );
}
